import { message, Modal } from "components";
import { PRODUCT_TYPE_FOR_ADD, ProductType, ProductUpsell } from "types/model/product";

type UpsellCardValidationProductType = ProductType | PRODUCT_TYPE_FOR_ADD;
type UpsellCardAction = "saving" | "publishing";

interface ValidateUpsellCardParams {
  productType?: UpsellCardValidationProductType;
  productUpsells?: ProductUpsell[];
  action: UpsellCardAction;
  onContinue: () => void;
}

const confirmationMessage =
  "No Upsell Card is configured. The paywall entry will not be displayed for this product. Are you sure you want to continue?";

export function validateUpsellCard({ productType, productUpsells, action, onContinue }: ValidateUpsellCardParams) {
  if (productUpsells?.length) {
    onContinue();
    return;
  }

  if (productType === "FREE" || productType === PRODUCT_TYPE_FOR_ADD.FREE) {
    message.error(
      new Error(`Upsell Card is required for Free products. Please configure an Upsell Card before ${action}.`)
    );
    return;
  }

  if (productType === "SINGLE_LEVEL" || productType === PRODUCT_TYPE_FOR_ADD.SINGLE_LEVEL) {
    Modal.confirm({
      title: "Confirm",
      content: confirmationMessage,
      okText: "Yes",
      cancelText: "No",
      onOk: onContinue,
    });
    return;
  }

  onContinue();
}
